import { ColorMode, Palette, SearchFilter } from './types';

export const filters: SearchFilter[] = [
  { label: 'General', value: 'general' },
  { label: 'Images', value: 'images' },
  { label: 'Videos', value: 'videos' },
  { label: 'News', value: 'news' },
];

export const advancedDefaults = {
  language: 'auto',
  timeRange: '',
  safeSearch: '1',
};

export const privacyPoints = [
  'Private Search',
  'No Personalized Search Results',
  'No Third Party Trackers',
  'No IP Address or User Session Logs',
  'No Selling of Personal Information',
];

export const donateUrl = 'https://gotdonations.org/#donate';

export const paletteOptions: Array<{ label: string; value: Palette }> = [
  { label: 'Blue', value: 'blue' },
  { label: 'Lavender', value: 'lavender' },
  { label: 'Forest', value: 'forest' },
  { label: 'Ocean', value: 'ocean' },
  { label: 'Slate', value: 'slate' },
  { label: 'Rose', value: 'rose' },
  { label: 'Aurora', value: 'aurora' },
  { label: 'Neon', value: 'neon' },
];

export const paletteValues = paletteOptions.map((option) => option.value);

export const colorModeOptions: Array<{ label: string; value: ColorMode }> = [
  { label: 'System', value: 'system' },
  { label: 'Light', value: 'light' },
  { label: 'Dark', value: 'dark' },
];
